import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'components/dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import FileDownloadOutlinedIcon from 'components/material-symbol/icons/FileDownload'
import { CSVLink } from 'react-csv'
import { useDialogTitleStyles } from 'components/dialog/use-dialog-title-styles'

const ExportTransactionsDialog = ({
  open,
  onClose,
  filename,
  csvData,
  monthLabel,
}) => {
  const classes = useDialogTitleStyles()

  return (
    <Dialog
      isOpen={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      showCloseButton
      classes={{ paper: classes.dialogPaper }}
    >
      {({ closeDialog }) => (
        <>
          <DialogTitle disableTypography classes={{ root: classes.titleRoot }}>
            <Typography component="h2" className={classes.title}>
              Export transactions
            </Typography>
            <Typography className={classes.bodyText}>
              Download a CSV of your transactions for {monthLabel}. The file
              will save to your device automatically.
            </Typography>
          </DialogTitle>
          <DialogActions className={classes.actions}>
            <Button onClick={closeDialog} color="primary">
              Cancel
            </Button>
            <Button
              component={CSVLink}
              variant="contained"
              color="primary"
              startIcon={<FileDownloadOutlinedIcon />}
              filename={filename}
              data={csvData}
              onClick={closeDialog}
            >
              Download CSV
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

ExportTransactionsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  filename: PropTypes.string.isRequired,
  csvData: PropTypes.arrayOf(PropTypes.object).isRequired,
  monthLabel: PropTypes.string.isRequired,
}

export default ExportTransactionsDialog
